var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "btn-group", attrs: { "data-toggle": "buttons" } },
        _vm._l(_vm.options, function(option, index) {
          return _c(
            "label",
            {
              key: option.name,
              staticClass: "btn btn-primary",
              class: { active: option.value == _vm.currentActiveOption.value },
              attrs: { disabled: _vm.disabled }
            },
            [
              _c("input", {
                ref: "option.name",
                refInFor: true,
                staticClass: "btn btn-primary",
                class: { disabled: _vm.disabled },
                attrs: {
                  disabled: _vm.disabled,
                  type: "radio",
                  autocomplete: "off",
                  checked: ""
                },
                on: {
                  click: function($event) {
                    return _vm.setToggle(option)
                  }
                }
              }),
              _vm._v("\n      " + _vm._s(option.name) + " \n      "),
              option.state
                ? [
                    option.state
                      ? _c(
                          "span",
                          { attrs: { id: `${_vm.toggleName}toggle${index}` } },
                          [_vm._v("(" + _vm._s(option.state.text) + ")")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("Tooltip", {
                      attrs: {
                        text: _vm.setToggleButtonTooltip(option),
                        "custom-class": "tooltip-black",
                        target: `#${_vm.toggleName}toggle${index}`
                      }
                    })
                  ]
                : _vm._e()
            ],
            2
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }